/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ReferralCodeGenerate_viewer$ref = any;
export type ReferralCodeGenerate_QueryVariables = {};
export type ReferralCodeGenerate_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": ReferralCodeGenerate_viewer$ref;
    }) | null;
};
export type ReferralCodeGenerate_Query = {
    readonly response: ReferralCodeGenerate_QueryResponse;
    readonly variables: ReferralCodeGenerate_QueryVariables;
};



/*
query ReferralCodeGenerate_Query {
  viewer {
    id
    ...ReferralCodeGenerate_viewer
  }
}

fragment ReferralCodeGenerate_viewer on Viewer {
  user {
    id
    role
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ReferralCodeGenerate_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "ReferralCodeGenerate_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ReferralCodeGenerate_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ReferralCodeGenerate_Query",
            "id": null,
            "text": "query ReferralCodeGenerate_Query {\n  viewer {\n    id\n    ...ReferralCodeGenerate_viewer\n  }\n}\n\nfragment ReferralCodeGenerate_viewer on Viewer {\n  user {\n    id\n    role\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '04318b73d897f0032a33ff784cf53b79';
export default node;
